var ClientOAuth2 = require('client-oauth2');
//REMEMBER: remove Authorization from headers in order to work with Facebook


import baseUrl from './baseUrl';

const redirect = baseUrl.getBaseUrlFrontend() + "oauth";

var providers = {
    'Facebook': new ClientOAuth2({
        clientId: '409126416211794',
        clientSecret: '5a1ac910974e9aa96e1d2b897d018ed8',
        accessTokenUri: 'https://graph.facebook.com/v8.0/oauth/access_token',
        authorizationUri: 'https://www.facebook.com/v8.0/dialog/oauth',
        redirectUri: redirect,
        scopes: ['email'],
        query: {
          state: {}
        }
    }),
    'Google': new ClientOAuth2({
        clientId: '906425901636-atta89mqhl7k1sasitok650hipdf18ij.apps.googleusercontent.com',
        clientSecret: 'SnvsXSCzG-495Jv7sbABm1yA',
        accessTokenUri: 'https://www.googleapis.com/oauth2/v4/token',
        authorizationUri: 'https://accounts.google.com/o/oauth2/v2/auth',
        redirectUri: redirect,
        scopes: ['email'],
        query: {
            'prompt': 'consent',
            'access_type': 'offline',
            state: {}
        }
    })
};

export default {
    get(provider) {
        return providers[provider];
    }
}



// WEBPACK FOOTER //
// ./src/services/oauth.js